<template>
    <div id="values">
        <div class="panels d-flex" ref="panels">
            <div
                :class="`${panel.theme} panel`"
                :key="i"
                v-for="(panel, i) in panels"
                v-html="panel.text"
            ></div>
            <wave :animate="animate" class="wave-top" />
            <wave :animate="animate" flipped />
        </div>
    </div>
</template>

<script>
import Wave from "@/components/Wave";

export default {
    name: "ValuePropsCarousel",
    components: {
        Wave
    },
    props: {
        audience: {
            default: "general"
        },
        animate: {
            type: Boolean
        }
    },
    computed: {
        panels() {
            switch (this.audience) {
                case "coach":
                    return [
                        {
                            text: "Keep your clients <b>longer</b>",
                            theme: "bg-primary"
                        },
                        {
                            text: "Deliver a <b>modern</b> experience",
                            theme: "bg-warning text-dark"
                        },
                        {
                            text: "Save time and stay <b>organized</b>",
                            theme: ""
                        },
                        {
                            text: "<b>Grow</b> your coaching business",
                            theme: "bg-success"
                        }
                    ];
                default:
                    return [
                        {
                            text: "Work with your <b>coach</b>",
                            theme: "bg-primary"
                        },
                        {
                            text: "Get a <b>personalized program</b>",
                            theme: "bg-warning text-dark"
                        },
                        {
                            text: "Stay <b>accountable</b> to your coach",
                            theme: ""
                        },
                        {
                            text: "See your <b>progress</b> over time",
                            theme: "bg-success"
                        }
                    ];
            }
        }
    },
    mounted() {
        if (this.animate) {
            setTimeout(() => {
                this.$refs.panels.classList.add("loaded");
            }, 300);
        } else {
            this.$refs.panels.classList.add("loaded");
        }
    }
};
</script>

<style>
#values b {
    text-transform: uppercase;
}
</style>

<style lang="scss" scoped>
#values {
    position: relative;
    overflow: hidden;
}
.panels {
    position: relative;
    background-color: inherit;
    opacity: 0;
    transition: opacity 1s ease;
}
.panels.loaded {
    opacity: 1;
}
.panel {
    height: 430px;
    width: 25%;
    text-align: center;
    padding: 4.5rem 0px;
    letter-spacing: 0.5px;
}
.panel:nth-of-type(1) {
    color: $white;
    background-image: url("~@/assets/marketing/1.png");
    background-size: 100%;
    background-position: center 1rem;
    background-repeat: no-repeat;
}
.panel:nth-of-type(2) {
    color: $dark;
    background-image: url("~@/assets/marketing/2.png");
    background-size: 65%;
    background-repeat: no-repeat;
    background-position: center bottom;
}
.panel:nth-of-type(3) {
    color: $white;
    background-image: url("~@/assets/marketing/3.png");
    background-size: 40%;
    background-repeat: no-repeat;
    background-position: center 7.5rem;
    background-color: #000;
}
.panel:nth-of-type(4) {
    color: $white;
    background-image: url("~@/assets/marketing/4.png");
    background-size: 40%;
    background-repeat: no-repeat;
    background-position: center 7.5rem;
}
.wave {
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 4rem;
    background-color: inherit;
}
.wave-top {
    top: -5px;
    left: 0px;
}

@media (max-width: #{map-get($grid-breakpoints, "sm")}) {
    #values {
        overflow-x: auto;
        scroll-snap-type: x mandatory;
    }
    #values .panels {
        width: calc(4 * 80vw);
    }
    #values .panel {
        scroll-snap-align: center;
        height: 420px;
        width: 80vw;
        text-align: center;
        padding: 4.5rem 0px;
        letter-spacing: 0.5px;
    }
}
</style>